import { formatDate } from "components/helpers";

const formatPercentage = value =>
  typeof value === "number" ? (value * 100).toFixed(2) + "%" : "";
const formatDecimal = value =>
  typeof value === "number" ? value.toFixed(2) : "";

export const getCallMetricsTableColumns = () => {
  return [
    {
      header: "Agent",
      id: "Agent",
      accessorKey: "agent",
    },
    {
      header: "Last Call",
      id: "last_call",
      accessorKey: "last_call",
      cell: ({ row }) => formatDate(row.original?.last_call),
    },
    {
      header: "# Dials",
      id: "# Dials",
      accessorKey: "num_dials",
    },
    {
      header: "Avg Dials/Day",
      id: "Avg Dials/Day",
      accessorKey: "avg_daily_dials",
      cell: ({ row }) => formatDecimal(row.original?.avg_daily_dials),
    },
    {
      header: "# Pickups",
      id: "# Pickups",
      accessorKey: "num_pickups",
    },
    {
      header: "Pickup Rate",
      id: "Pickup Rate",
      accessorKey: "pickup_rate",
      cell: ({ row }) => formatPercentage(row.original?.pickup_rate),
    },
    {
      header: "# Leads",
      id: "# Leads",
      accessorKey: "num_leads",
    },
    {
      header: "Conversion Rate",
      id: "Conversion Rate",
      accessorKey: "conversion_rate",
      cell: ({ row }) => formatPercentage(row.original?.conversion_rate),
    },
    {
      header: "Hours Calling",
      id: "Hours Calling",
      accessorKey: "hours_calling",
      cell: ({ row }) => formatDecimal(row.original?.hours_calling),
    },
    {
      header: "Handle Time",
      id: "Handle Time",
      accessorKey: "handle_time",
      cell: ({ row }) => formatDecimal(row.original?.handle_time),
    },
    {
      header: "Working Days",
      id: "Working Days",
      accessorKey: "working_days",
    },
  ];
};
